const onKeyDownWrapper = (event: KeyboardEvent, callback: () => void) => {
   if (event.key === 'Enter' || event.key === ' ') {
      callback();
   }
};

const accessibilityHelper = {
   onKeyDownWrapper,
};

export default accessibilityHelper;
